// Copyright (c) 2016 Deere & Company

import PartsClaimContainer from '../../claim/parts/state-connector';

export default {
    component: PartsClaimContainer,
    name: 'PARTS',
    path: 'parts/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-parts-claim-route.js